
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Amiens dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Amiens certifiée Google Partner, accompagne les entreprises amiénoises pour augmenter leur visibilité en ligne et générer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Amiens dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Amiens certifiée Google Partner, accompagne les entreprises amiénoises pour augmenter leur visibilité en ligne et générer plus de prospects.",
        },
      ],
    };
  },
};
